import { useLocation } from "react-router";
import { contactFormUrl } from "@pages/Article/components/ArticlePurchaseLink/constants";

const useFeedbackFormUrl = () => {
  const { pathname, search } = useLocation();
  const sourceUrl = pathname + search;
  return contactFormUrl + `&source_url=${sourceUrl}`;
};

export default useFeedbackFormUrl;
